// The MouldOS logo (the director, 2 Nov 2026: logo "5.2" -- two diamonds
// stacked and overlapping, the shared middle lit: where planning meets
// production). One drawing for the top bar, the phone bar, sign-in and
// activation; public/favicon.svg and the app icons are the same drawing. The
// brand files and guidelines are in Desktop/mouldos/Brand.

const TONES = ['#14b8a6', '#0d9488', '#5eead4'];   // top, bottom, the lit middle

// The symbol alone. `size`: its height in px (it is 40 wide to 48 tall).
export function Mark({ size = 22, label = null }) {
  return (
    <svg width={Math.round(size * 40 / 48)} height={size} viewBox="12 8 40 48" style={{ display: 'block', flex: 'none' }}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}>
      <path d="M32 8 L52 22 L32 36 L12 22 Z" fill={TONES[0]} />
      <path d="M32 28 L52 42 L32 56 L12 42 Z" fill={TONES[1]} />
      <path d="M32 28 L37.71 32 L32 36 L26.29 32 Z" fill={TONES[2]} />
    </svg>
  );
}

// The symbol beside the name: "Mould" in the text colour, "OS" in teal, Plus
// Jakarta Sans 800 (loaded in public/index.html). `size`: the name's font size in px.
export default function Logo({ size = 16, text = '#f0f2f5' }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.32), lineHeight: 1 }} aria-label="MouldOS">
      <Mark size={Math.round(size * 1.45)} />
      <span aria-hidden="true" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif", fontWeight: 800, fontSize: size, letterSpacing: '-0.035em', color: text, whiteSpace: 'nowrap' }}>
        Mould<span style={{ color: TONES[0] }}>OS</span>
      </span>
    </span>
  );
}
